
define('modules/application/wizard/steps/zoneStep/complexZoneStep/energyManagementZoneStep/zonesMenuView',[
  "app",

  // Libs
  "backbone",
  "jqueryUi",

  //Class
  "../zonesMenuView",
  "./zoneMenuView",
  "../../separatorMenuView"
],

function(
  app,
  Backbone,
  jQueryUi,
  ZonesMenuView,
  ZoneMenuView,
  SeparatorMenuView) {

  var energyManagementZonesMenuView = ZonesMenuView.extend({

    template           : "application/wizard/steps/zones/complexZones/energyManagementZones/menu",
    addConstructors : function() {
      this.ZoneMenuView = ZoneMenuView;
    },

    initialize         : function() {
      ZonesMenuView.prototype.initialize.apply(this);

      window.BticinoS4B.eventAggregator.unbind("systems:changed", this.render);
      window.BticinoS4B.eventAggregator.bind("systems:changed", this.render, this);
    },

    checkIfThisZoneIsShowable : function(zoneName) {
      var systems       = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
          systemsLength = systems ? systems.length : 0,
          isShowable    = false,
          i             = 0;

      switch(zoneName)
      {
      case "IDS_WAM8_25_3":
        for (i=0; i<systemsLength; i++)
        {
          if (systems[i]==="lightsAndRollingShutters")
          {
            isShowable = true;
            break;
          }
        }
        break;
      case "IDS_W3_9010":
      case "IDS_W3_9011":
        isShowable = true;
        break;
      case "IDS_W3_9013":
      case "IDS_W3_9014":
        for (i=0; i<systemsLength; i++)
        {
          if (systems[i]==="loadsControl")
          {
            isShowable = true;
            break;
          }
        }
        break;

      case "IDS_WAM8_25_2":
        for (i=0; i<systemsLength; i++)
        {
          if (systems[i]==="traditional")
          {
            isShowable = true;
            break;
          }
        }
        break;
      }
      return isShowable;
    },

    checkIfThisSeparatorIsShowable : function(zoneName) {
      var systems       = BticinoS4B.Instances.Models.ApplicationModel.get("choosenSystems"),
          systemsLength = systems ? systems.length : 0,
          isShowable    = false,
          i             = 0;

      switch(zoneName)
      {
      case "IDS_W3_9002":
        for (i=0; i<systemsLength; i++)
        {
          if ( (systems[i]==="lightsAndRollingShutters") || (systems[i]==="rollingShutters") )
          {
            isShowable = true;
            break;
          }
        }
        break;
      case "IDS_W3_9012":
        isShowable = true;
        break;
      case "IDS_W3_9004":
        for (i=0; i<systemsLength; i++)
        {
          if (systems[i]==="loadsControl")
          {
            isShowable = true;
            break;
          }
        }
        break;
      case "IDS_W3_9009":
        for (i=0; i<systemsLength; i++)
        {
          if (systems[i]==="traditional")
          {
            isShowable = true;
            break;
          }
        }
        break;
      }
      return isShowable;
    },

    insertAdditionalZones : function() {
      //Variable declarations
      var viewToSelect,
          that                  = this, viewToInsert,
          additionalZones       = this.model.additionalZones,
          additionalZonesLength = additionalZones.length,
          i                     = 0;

      //Inserting views for the additional zones
      for (i=0; i<additionalZonesLength; i++)
      {
        if (additionalZones[i].role!=="separator")
        {
          if (this.checkIfThisZoneIsShowable(additionalZones[i].get("name")))
          {
            additionalZones[i].set("stepEventAggregator", that.options.stepEventAggregator);
            additionalZones[i].set("sortable", false);
            viewToInsert = new that.ZoneMenuView({model : additionalZones[i], stepEventAggregator : that.options.stepEventAggregator});
            if (!viewToSelect)
              viewToSelect = viewToInsert;
            viewToInsert.setAsLocked();
            that.insertView("#zoneList", viewToInsert);
          }
        }
        else
        {
          if (this.checkIfThisSeparatorIsShowable(additionalZones[i].name))
          {
            viewToInsert      = new SeparatorMenuView();
            viewToInsert.name = additionalZones[i].name;
            that.insertView("#zoneList", viewToInsert);
          }
        }
      }

      return viewToSelect;
    },

    insertRegularZones    : function() {
      //Doing nothing in the first version
    },

    beforeRender : function() {
      var viewToSelect;
      var additionalZoneToInsert = this.insertAdditionalZones();
      var regularZoneToInsert    = this.insertRegularZones();

      if (additionalZoneToInsert)
        window.BticinoS4B.eventAggregator.trigger("zone:selected", additionalZoneToInsert);

      if (regularZoneToInsert)
      {
        new this.ZoneDetailView({
          model               : _.extend({stepEventAggregator : this.options.stepEventAggregator}, regularZoneToInsert.model),
          sections            : this.options.model.get("sections")
        });
        window.BticinoS4B.eventAggregator.trigger("zone:selected", regularZoneToInsert);
      }
    }
  });

  //Creating final energyManagementZoneStep class
  energyManagementZonesMenuView.extend({
    objClass      : "energyManagementZonesMenuView"
  });

  // Required, return the module for AMD compliance
  return energyManagementZonesMenuView;

});